export const ADD_FAILED_ORDER = "ADD_FAILED_ORDER"
export const REMOVE_FAILED_ORDER = "REMOVE_FAILED_ORDER"